import { Component, OnDestroy } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
// services
import { StartupService } from '../services/startup.service';
import { SharedService } from '../shared/services/shared.service';
// Third Party
import { Subscription } from 'rxjs';
// Models
import { Master } from '../shared/models/company';
//components
import { DashboardComponent } from '../reporting/dashboard/dashboard.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('2000ms', style({ opacity: 1 })),
      ]),
    ]),
  ],
  standalone: true,
  imports: [DashboardComponent],
})
export class HomeComponent implements OnDestroy {
  subscriptions = new Subscription();
  readonly heroPills = [
    'ATF & NICS integrated',
    'Offline-first PWA',
    'Live distributor feeds',
  ];

  readonly complianceBadges = [
    { icon: '4473', title: 'ATF Form 4473', subtitle: 'Fully Compliant' },
    { icon: 'SSL', title: '256-bit SSL', subtitle: 'Bank-grade Security' },
    { icon: 'SOC', title: 'SOC 2 Type II', subtitle: 'Certified' },
    { icon: 'BBB', title: 'BBB Accredited', subtitle: 'A+ Rating' },
    { icon: 'NSSF', title: 'NSSF Member', subtitle: 'Industry Partner' },
    { icon: 'NICS', title: 'NICS Integrated', subtitle: 'Instant Checks' },
  ];

  readonly trustMetrics = [
    { value: '500+', title: 'Active Dealers' },
    { value: '2M+', title: 'Transactions Processed' },
    { value: '99.9%', title: 'Uptime' },
    { value: '24/7', title: 'Support' },
  ];

  constructor(
    public startupService: StartupService,
    public sharedService: SharedService,
  ) {
    this.subscriptions.add(
      this.sharedService.master_file_retrieved$.subscribe((account: Master) => {
        this.sharedService.closeStatusSpinner();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
